import { defineComponent as U, useCssModule as V, ref as s, computed as f, provide as q, onMounted as J, onUpdated as R, onDeactivated as F, onBeforeUnmount as H, createElementBlock as K, openBlock as k, createElementVNode as m, normalizeClass as I, normalizeStyle as W, renderSlot as A, createBlock as Y, createCommentVNode as Z, withCtx as N, unref as h, createTextVNode as G, createVNode as P, toDisplayString as Q } from "vue";
import X from "lodash-es/debounce";
import ee from "lodash-es/uniqueId";
import { DEBOUNCE as te } from "./constants.js";
import { t as oe } from "./locale.js";
import re from "./Dropdown.js";
import ae from "./Icon.js";
const se = Object.freeze({
  key: Symbol("TABS_INJECTION_KEY")
});
var M = /* @__PURE__ */ ((i) => (i.Line = "line", i.Enclosed = "enclosed", i))(M || {});
const ie = {
  class: "stash-tabs tw-relative",
  role: "tabList",
  "data-test": "stash-tabs"
}, ne = ["aria-controls", "aria-expanded", "onClick"], le = ["id"], fe = /* @__PURE__ */ U({
  __name: "Tabs",
  props: {
    activeTab: {},
    variant: { default: M.Line }
  },
  emits: ["update:activeTab"],
  setup(i, { emit: O }) {
    const B = O, d = i, D = V(), l = s(), c = s(), n = s(void 0), S = "IntersectionObserver" in window, a = s(/* @__PURE__ */ new Set()), g = s(0), E = s(), x = ee("more-dropdown-menu-"), u = s(!1), v = f({
      get() {
        return d.activeTab;
      },
      set(t) {
        B("update:activeTab", t);
      }
    });
    function $(t) {
      v.value = t;
    }
    q(se.key, {
      activeTab: f(() => v.value),
      variant: f(() => d.variant),
      setActiveTab: $
    });
    function y() {
      var p, L, T;
      if (!S || !l.value)
        return;
      const t = Array.from((p = l.value) == null ? void 0 : p.children), _ = {
        root: l.value,
        rootMargin: "0px",
        threshold: Array.from({ length: 100 }).map((e, o) => (o + 1) / 100)
      };
      if (n.value = new IntersectionObserver((e) => {
        e.forEach((o) => {
          const r = o.target.getAttribute("id");
          o.intersectionRatio > 0.94 ? a.value.has(r) && a.value.delete(r) : r && !a.value.has(r) && a.value.add(r);
        });
      }, _), t.forEach((e) => {
        var o;
        (o = n.value) == null || o.observe(e), a.value.has(e.getAttribute("id")) ? e.classList.add("tw-invisible") : e.classList.remove("tw-invisible");
      }), g.value = ((T = (L = E.value) == null ? void 0 : L.$el) == null ? void 0 : T.getBoundingClientRect().width) || 0, !c.value)
        return;
      Array.from(c.value.children).forEach((e) => {
        var r;
        const o = e.firstElementChild;
        if (o.className = "", e.className = "", e.classList.add(
          D["menu-tab"],
          "tw-flex",
          "tw-items-center",
          "tw-justify-between",
          "tw-rounded",
          "tw-text-sm",
          "tw-p-1.5",
          "tw-text-left",
          "tw-cursor-pointer",
          "tw-text-ice-700",
          "hover:!tw-bg-ice-200",
          "aria-disabled:tw-text-ice-500",
          "aria-disabled:tw-pointer-events-none",
          "aria-disabled:hover:tw-text-ice-500",
          "aria-disabled:hover:tw-bg-inherit",
          "aria-disabled:hover:tw-cursor-default",
          "aria-selected:tw-bg-blue-100"
        ), (r = e.querySelector(".stash-tabs__dropdown-selected-tab-icon")) == null || r.remove(), e.getAttribute("id") === `tab-${v.value}`) {
          const b = document.createElement("span");
          b.className = "stash-tabs__dropdown-selected-tab-icon", b.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" class="tw-text-blue-500 tw-w-6 tw-h-6" viewBox="0 0 24 24" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M20.707 6.854 9 18.561l-5.707-5.707 1.414-1.414L9 15.733 19.293 5.44l1.414 1.414Z" clip-rule="evenodd"/></svg>', e.appendChild(b);
        }
        a.value.has(e.getAttribute("id")) ? e.classList.remove("tw-hidden") : e.classList.add("tw-hidden"), e.removeEventListener("click", () => {
        });
      });
    }
    const z = X(y, te.FAST, { leading: !0 });
    function w() {
      n.value && (n.value.disconnect(), n.value = void 0);
    }
    J(() => {
      y();
    }), R(() => {
      w(), z();
    }), F(() => {
      w();
    }), H(() => {
      w();
    });
    function j(t) {
      t(), u.value = !u.value;
    }
    return (t, _) => (k(), K("div", ie, [
      m("ul", {
        ref_key: "tabListEl",
        ref: l,
        style: W({
          width: `calc(100% - ${g.value}px)`
        }),
        class: I(["stash-tabs-list tw-flex tw-items-end", {
          "stash-tabs-list--line": t.variant === "line",
          "stash-tabs-list--enclosed": t.variant === "enclosed",
          "tw-gap-6": t.variant === "line"
        }])
      }, [
        A(t.$slots, "default"),
        a.value.size ? (k(), Y(re, {
          key: 0,
          ref_key: "moreDropdownEl",
          ref: E,
          class: "!tw-absolute tw-right-0 tw-top-0"
        }, {
          toggle: N(({ toggle: C }) => [
            m("button", {
              "aria-haspopup": "menu",
              "aria-controls": h(x),
              "aria-expanded": u.value,
              class: I(["tw-flex tw-cursor-pointer tw-items-center tw-justify-center tw-border-solid tw-px-6 tw-py-1.5 tw-text-sm tw-font-medium tw-text-blue-500 hover:tw-text-blue-700", { "tw-border-t-4 tw-border-transparent": d.variant === "enclosed" }]),
              type: "button",
              onClick: (p) => j(C)
            }, [
              G(Q(h(oe)("ll.more")) + " ", 1),
              P(ae, { name: "caret-down" })
            ], 10, ne)
          ]),
          default: N(() => [
            m("ul", {
              id: h(x),
              ref_key: "moreDropdownMenuEl",
              ref: c,
              class: "tw-space-y-1.5 tw-px-1.5 tw-pb-1.5",
              role: "menu"
            }, [
              A(t.$slots, "default")
            ], 8, le)
          ]),
          _: 3
        }, 512)) : Z("", !0)
      ], 6)
    ]));
  }
});
export {
  se as T,
  fe as _,
  M as a
};
//# sourceMappingURL=Tabs.vue_vue_type_script_setup_true_lang-CmnBP4i1.js.map
